// @ts-strict-ignore
import React from 'react'
import { Linking, View } from 'react-native'
import styled from 'styled-components/native'
import { SafeAreaView } from 'react-native-safe-area-context'

import I18n from 'APP/I18n'
import Config from 'APP/Config'
import { CustomSupportPage, CustomSupportPageButton } from 'APP/Config/types'

import DialogueAutolink from 'APP/Components/DialogueAutolink'
import BulletListItem from 'APP/Components/BulletListItem'
import Alert from 'APP/Converse/Alert'
import Button from 'APP/Converse/Button'
import { ResponsiveScrollView, ResponsiveView } from 'APP/Converse/Layout'
import LogoHeader from 'APP/Components/LogoHeader'

import Images from 'APP/Themes/Images'

const ScreenContainer = styled(SafeAreaView).attrs({
  edges: ['bottom', 'left', 'right'],
})`
  flex: 1;
`

const ContentContainer = styled(ResponsiveView)`
  gap: ${({ theme }) => theme.metrics.baseMargin * 2}px;
  padding: ${({ theme }) => theme.metrics.baseMargin}px;
`

const ContentFooterContainer = styled.View`
  gap: ${({ theme }) => theme.metrics.baseMargin}px;
`

const ContactUsScreen: React.FC = () => {
  const { title, body } = Config.CUSTOM_SUPPORT_PAGE as CustomSupportPage

  const openURL = async (url: string) => {
    try {
      await Linking.openURL(url)
    } catch (_) {
      Alert.alert(I18n.t('CannotOpenUrl.title'), I18n.t('CannotOpenUrl.body'), [
        { text: I18n.t('CannotOpenUrl.ok') },
      ])
    }
  }

  const renderButtons = () => {
    const buttonConfigs = Config.CUSTOM_SUPPORT_PAGE?.buttons
    const validButtonConfigs = buttonConfigs?.filter((b) => b?.url && b?.label)

    if (!validButtonConfigs || validButtonConfigs.length === 0) return null

    return validButtonConfigs.map((buttonConfig: CustomSupportPageButton) => {
      const label = buttonConfig.label[I18n.baseLocale]
      const url = buttonConfig.url[I18n.baseLocale]

      return (
        <Button
          variant="primary"
          widthVariant="full"
          key={label}
          title={label}
          onPress={() => openURL(url!)}
          analyticsName="ContactUs"
        />
      )
    })
  }

  const renderBulletPoints = () => {
    const bulletConfigs = Config.CUSTOM_SUPPORT_PAGE?.bulletPoints

    if (!bulletConfigs || bulletConfigs.length === 0) return null

    return bulletConfigs.map((bulletConfig) => {
      const label = bulletConfig[I18n.baseLocale]

      return <BulletListItem key={label}>{label}</BulletListItem>
    })
  }

  return (
    <ScreenContainer>
      <ResponsiveScrollView alwaysBounceVertical={false} keyboardShouldPersistTaps="always">
        <ContentContainer>
          <LogoHeader
            source={Images.logoBlue}
            title={title[I18n.baseLocale]!}
            subtitle={<DialogueAutolink text={body[I18n.baseLocale]} />}
          />
          <View>{renderBulletPoints()}</View>
          <ContentFooterContainer>{renderButtons()}</ContentFooterContainer>
        </ContentContainer>
      </ResponsiveScrollView>
    </ScreenContainer>
  )
}

export default ContactUsScreen
